import Toastify from "toastify-js";
import IMask from "imask";

export function initFluentForm() {
  return [
    ...document.querySelectorAll(
      "form.ffs_default:not(.-initialized), form.embed-form:not(.-initialized)"
    ),
  ].map((form) => new FluentForm(form));
}

/**
 * Base class to handle ajax forms. Will be initialized for all form.ajax-form nodes.
 *
 */
export class FluentForm {
  _dom = {
    form: null,
    submitBtns: null,
  };

  formId = null;

  fluentformInstance = null;

  callback = null;

  defaultInputTextMaxLength = 255;
  defaultInputTextAreaMaxLength = 130000;

  _config = {
    vehicleDamageFieldsMaxLength: {
      KMStand: 18,
      ownVehicleDamage: 255,
      "driverName[first_name]": 127,
      "driverName[last_name]": 127,
      "driverAddress[address_line_1]": 94,
      "driverAddress[address_line_2]": 5,
      driverPhone: 40,
      // "driverAddress[zip]": 20,
      "driverAddress[city]": 100,

      "accidentLocation[address_line_1]": 255,
      officerName: 255,
      diaryNo: 255,
      department: 255,
      gebuehrenplWarning: {
        mask: Number,
        scale: 2,
        signed: false,
        thousandsSeparator: "",
        padFractionalZeros: true,
        normalizeZeros: true,
        radix: ",",
        mapToRadix: ["."],
        min: 0,
        max: 99999999.99,
      },
      bloodTest: {
        mask: Number,
        scale: 2,
        signed: false,
        thousandsSeparator: "",
        padFractionalZeros: true,
        normalizeZeros: true,
        radix: ",",
        mapToRadix: ["."],
        min: 0,
        max: 99999999.99,
      },

      agePersonInvolved: {
        mask: Number,
        scale: 0,
        signed: false,
        thousandsSeparator: "",
        padFractionalZeros: true,
        normalizeZeros: true,
        radix: ".",
        mapToRadix: ["."],
        min: 0,
        max: 100,
      },
      "personInvolved[first_name]": 127,
      "personInvolved[last_name]": 127,
      "personInvolvedAddress[address_line_1]": 100,
      phonePersonInvolved: 40,
      // "personInvolvedAddress[zip]": 20,
      manufacturerPersonInvolved: 255,
      "personInvolvedAddress[city]": 100,
      insurancePersonInvolved: 255,
      insuranceNoOfPersonInvolved: 255,

      addressFirstWitness: 32768,
      addressSecondWitness: 32768,
      accidentOccurence: 40000,
      fullnameFirstWitness: 255,
      fullnameSecondWitness: 255,
      statusFirstWitness: 255,
      statusSecondWitness: 255,
      phoneFirstWitness: 40,
      phoneSecondWitness: 40,
      otherInformation: 255,

      jobPersonInvolved: 255,
      relationshipStatusPersonInvolved: 255,
      injuriesPersonInvolved: 255,
    },
    vehicleConfigurationFieldsMaxLength: {
      company: 255,
      phone: 20,
      "names[first_name]": 40,
      "names[last_name]": 80,
      "mailingData[address_line_2]": 255,
      "mailingData[city]": 40,
      "billingData[address_line_2]": 255,
      "billingData[city]": 40,
      "deliveryData[address_line_2]": 255,
      "deliveryData[city]": 40,
      "contactData[first_name]": 40,
      "contactData[last_name]": 80,
      contactPhone: 20,
      contactComment: 255,
    },
    vehicleKmReportFieldsMaxLength: {
      "names[first_name]": 30,
      "names[last_name]": 30,
    },
    vehicleCarReturnFieldsMaxLength: {
      "names[first_name]": 30,
      "names[last_name]": 30,
      company: 50,
      "contactAddress[address_line_1]": 50,
      // "contactAddress[zip]": 20,
      "contactAddress[city]": 50,
      "contact[first_name]": 50,
      "contact[last_name]": 50,
      contactPhone: 20,
      contactComment: 32768,
    },
    defaultFieldsMaxLength: {
      first_name: 40,
      last_name: 80,
      phone: 20,
    },
  };

  constructor(elemt) {
    this._dom.form = elemt;

    if (this._dom.form.classList.contains("-initialized")) {
      return;
    }

    this._dom.form.classList.add("-initialized");

    this.formId = this._dom.form.dataset.form_id;

    this._dom.form.setAttribute("novalidate", true);

    const actionField = this._dom.form.querySelector("input[name='action']");

    if (actionField) {
      this._dom.form.setAttribute("action", actionField.value);
      this.handleSubmit();
    }

    this.initFormListeners();

    this._dom.submitBtns = this._dom.form.querySelectorAll(
      "button[type=submit], input[type=submit]"
    );

    this.handleFormSubmitResponse();
  }

  initFormListeners() {
    const formInstance = jQuery(this._dom.form);
    this.fluentformInstance = fluentFormApp(formInstance);

    this._dom.form
      .querySelectorAll("input[name*='zip']")
      .forEach(this.initZipCode.bind(this));

    this._dom.form
      .querySelectorAll(".kennzeichen_field")
      .forEach(this.initKennzeichen.bind(this));

    this._dom.form
      .querySelectorAll(".ff-dropzone")
      .forEach(this.initDropzone.bind(this));

    this._dom.form
      .querySelectorAll(
        "input[type='text'], input[type='number'], input[type='email'], input[type='tel'], textarea"
      )
      .forEach((input) => {
        if (input.name.includes("zip")) {
          return;
        }

        const isKennzeichen = input.closest(".kennzeichen_field");
        if (isKennzeichen) {
          return;
        }

        const isTextArea = input.tagName === "TEXTAREA";
        const formId = this.formId;
        let fieldsWithMaxLength = this._config.defaultFieldsMaxLength;

        if (formId == appConfig.vehicleDamageFormID) {
          fieldsWithMaxLength = this._config.vehicleDamageFieldsMaxLength;
        } else if (formId == appConfig.vehicleConfigurationFormID) {
          fieldsWithMaxLength =
            this._config.vehicleConfigurationFieldsMaxLength;
        } else if (formId == appConfig.vehicleKmReportFormID) {
          fieldsWithMaxLength = this._config.vehicleKmReportFieldsMaxLength;
        } else if (formId == appConfig.vehicleCarReturnFormID) {
          fieldsWithMaxLength = this._config.vehicleCarReturnFieldsMaxLength;
        }

        const hasCustomMaxLength = Object.keys(fieldsWithMaxLength).includes(
          input.name
        );

        if (hasCustomMaxLength) {
          this.initMaxLength(input, fieldsWithMaxLength[input.name] ?? null);
        } else if (isTextArea) {
          this.initMaxLength(input, this.defaultInputTextAreaMaxLength);
        } else {
          this.initMaxLength(input, this.defaultInputTextMaxLength);
        }
      });
  }

  initDropzone(dropzone) {
    const config = {
      attributes: false,
      childList: true,
      subtree: true,
    };
    const wrapper = dropzone.querySelector(".ff-el-input--content");
    const input = dropzone.querySelector("input[type='file']");

    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          // Fix for the error message not being removed
          const error = wrapper.querySelector(".error");
          const text = error?.textContent;
          if (error && (text === undefined || text === "")) {
            error.remove();
          }

          // Check if the total file size exceeds 60 MB
          if (this.sumFileSizes(dropzone) > 60) {
            dropzone.classList.add("force-error");

            this.fluentformInstance.addFieldValidationRule(
              input.name,
              "force_failed",
              {
                value: true,
                message: appConfig.validationMessages.maxTotalFileSize,
              }
            );
          } else {
            if (dropzone.classList.contains("force-error")) {
              error?.remove();
            }

            dropzone.classList.remove("force-error");

            this.fluentformInstance.removeFieldValidationRule(
              input.name,
              "force_failed"
            );
          }
        }
      }
    });

    observer.observe(wrapper, config);
  }

  sumFileSizes(dropzone) {
    let totalBytes = 0;

    const sizes = Array.from(
      dropzone.querySelectorAll(".ff-upload-filesize")
    ).map((size) => size.textContent);

    sizes.forEach((sizeStr) => {
      const regex = /([\d.]+)\s*(MB|KB|B)/i;
      const match = sizeStr.match(regex);

      if (match) {
        const value = parseFloat(match[1]);
        const unit = match[2].toUpperCase();

        switch (unit) {
          case "MB":
            totalBytes += value * 1024 * 1024;
            break;
          case "KB":
            totalBytes += value * 1024;
            break;
          case "B":
            totalBytes += value;
            break;
        }
      }
    });

    const totalMB = totalBytes / (1024 * 1024);
    return totalMB;
  }

  initKennzeichen(parent) {
    const cityInput = parent.querySelector("input:nth-child(1)");
    const letterInput = parent.querySelector("input:nth-child(3)");
    const numberInput = parent.querySelector("input:nth-child(4)");
    const prepare = (str) => str.toUpperCase();

    IMask(cityInput, {
      mask: "aaa",
      prepare,
    });

    IMask(letterInput, {
      mask: "xx",
      prepare,
      definitions: {
        x: /[0-9a-zA-Z]/,
      },
    });

    IMask(numberInput, {
      mask: "xxxx",
      prepare,
      definitions: {
        x: /[0-9eEhH]/,
      },
    });

    cityInput.addEventListener("change", (e) =>
      this.kennzeichenValidation(parent, cityInput, letterInput, numberInput)
    );
    letterInput.addEventListener("change", (e) =>
      this.kennzeichenValidation(parent, cityInput, letterInput, numberInput)
    );
    numberInput.addEventListener("change", (e) =>
      this.kennzeichenValidation(parent, cityInput, letterInput, numberInput)
    );

    if (parent.dataset?.required === "true") {
      this.fluentformInstance.addFieldValidationRule(
        cityInput.name,
        "force_failed",
        {
          value: true,
          message: appConfig.validationMessages.required,
        }
      );
    }
  }

  initZipCode(input) {
    IMask(input, {
      mask: "00000",
    });

    input.addEventListener("change", (e) => {
      const inputValue = e.target.value;
      if (
        this.zipcodeValidation(inputValue) ||
        (inputValue == "" && e.target.getAttribute("aria-required") === "false")
      ) {
        this.fluentformInstance.removeFieldValidationRule(
          input.name,
          "force_failed"
        );
      } else {
        this.fluentformInstance.addFieldValidationRule(
          input.name,
          "force_failed",
          {
            value: true,
            message: appConfig.validationMessages.zip,
          }
        );
      }
    });
  }

  initMaxLength(input, maxLength) {
    const hasMask = typeof maxLength === "object";

    IMask(
      input,
      hasMask
        ? maxLength
        : {
            mask: new RegExp(`^.{0,${maxLength}}$`),
          }
    );

    if (!hasMask) {
      input.addEventListener("change", (e) => {
        const inputValue = e.target.value;
        if (this.maxLengthValidation(inputValue, maxLength)) {
          this.fluentformInstance.removeFieldValidationRule(
            input.name,
            "force_failed"
          );
        } else {
          this.fluentformInstance.addFieldValidationRule(
            input.name,
            "force_failed",
            {
              message: appConfig.validationMessages.maxLength.replace(
                "{maxLength}",
                typeof maxLength === "object" ? maxLength.value : maxLength
              ),
            }
          );
        }
      });
    }
  }

  kennzeichenValidation(parent, cityInput, letterInput, numberInput) {
    const isRequired = parent.dataset?.required === "true";

    const isEmpty =
      cityInput.value === "" &&
      letterInput.value === "" &&
      numberInput.value === "";

    const cityPattern = /^[A-Z]{1,3}$/;
    const letterPattern = /^[0-9A-Z]{1,2}$/;
    const numberPattern = /^\d{1,4}[EH]?$/;

    const isValid =
      cityPattern.test(cityInput.value) &&
      letterPattern.test(letterInput.value) &&
      numberPattern.test(numberInput.value);

    if (isValid || (isEmpty && !isRequired)) {
      this.fluentformInstance.removeFieldValidationRule(
        cityInput.name,
        "force_failed"
      );
    } else {
      this.fluentformInstance.addFieldValidationRule(
        cityInput.name,
        "force_failed",
        {
          value: true,
          message: appConfig.validationMessages.kennzeichen,
        }
      );
    }
  }

  zipcodeValidation(value) {
    const zipPattern = /^\d{5}(-\d{4})?$/;

    if (!zipPattern.test(value)) {
      return false;
    }

    return true;
  }

  maxLengthValidation(value, maxLength) {
    const maxLengthPattern = new RegExp(`^.{0,${maxLength}}$`);

    if (!maxLengthPattern.test(value)) {
      return false;
    }

    return true;
  }

  handleSubmit() {
    this._dom.form.addEventListener("submit", (e) => {
      const newForm = document.createElement("form");
      newForm.method = "POST";
      newForm.action = this._dom.form.getAttribute("action");
      newForm.target = "_self";
      newForm.style.display = "none";
      document.body.appendChild(newForm);

      const elements = jQuery(this._dom.form.children).clone();
      jQuery(newForm).html(elements);

      this.callback = (formId) => {
        if (formId != this._dom.form.dataset.form_id) {
          return;
        }

        newForm.submit();
      };
    });
  }

  handleFormSubmitResponse() {
    jQuery(document).ajaxComplete((event, xhr, settings) => {
      let formData = new URLSearchParams(settings.data);
      let action = formData.get("action");
      let formId = formData.get("form_id");

      if (formId !== this.formId) {
        return;
      }

      if (xhr.status === 200 && action === "fluentform_submit") {
        const vehicleConfigurationFormID = appConfig.vehicleConfigurationFormID
          ? parseInt(appConfig.vehicleConfigurationFormID)
          : 0;

        if (formId == vehicleConfigurationFormID) {
          const submitContainer = document.querySelector(
            ".ff-inner_submit_container"
          );
          const successSection = document.querySelector(
            ".b-vehicle-configurator__success"
          );
          submitContainer?.remove();
          successSection.classList.add("-active");
        } else {
          if (this.callback) {
            this.callback(formId);
            return;
          }

          const parent = this._dom.form.closest(".b-form-contact");
          const successSection = parent.querySelector(
            ".b-form-contact__confirmation"
          );

          if (successSection) {
            successSection.classList.add("-active");
          }

          const successMessage = parent.querySelector(
            `#fluentform_${formId}_success`
          );
          if (successMessage) {
            successMessage.style.display = "none";
          }
        }
      }

      if (xhr?.responseJSON?.errorToastMessage) {
        Toastify({
          text: xhr.responseJSON.errorToastMessage,
          className: "error",
          duration: 5000,
          gravity: "bottom",
          position: "right",
        }).showToast();
        if (typeof grecaptcha !== "undefined") {
          grecaptcha.reset();
        }
      }
    });
  }
}
